/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    object,
} from 'prop-types';
import PageHeading from './PageHeading';
import Data from './ViewData';

const styles = (theme)  => ({
    container: {
        display: 'block',
        margin: '10px',
    },
    headingBlock: {
        display: 'block',
        margin: '16px',
        lineHeight: '20px',
    },
    headerImage: {
        margin: '15px auto',
        display: 'flex',
        position: 'relative',
        minWidth: '1px',
        minHeight: '1px',
        alignItems: 'center',
        justifyContent: 'center',
    },
    heading: {
        fontSize: '24px',
        textAlign: 'center',
        fontFamily: 'Roboto, sans-serif',
        fontWeight: '400',
        color: theme.palette.colorHeadingSympathy,
        letterSpacing: '0.03em',
    },
    casketFlowersImage: {
        alignItems: 'center',
    },
    standingFlowersImage: {
        alignItems: 'center',
    },
    friends: {
        alignItems: 'center',
    },
    freshFlowers: {
        fontSize: '14px',
        margin: '4px',
    },
    content: {
        fontSize: '14px',
        letterSpacing: '0.03em',
        fontFamily: 'Roboto , sans-serif',
        color: theme.palette.contentColor,
    },
    linkTitle: {
        color: theme.palette.colorIconHeader,
    },
    contactUs: {
        fontSize: '14px',
        margin: '4px',
    },
    imageContainer: {
        display: 'flex',
        position: 'relative',
        minWidth: '1px',
        minHeight: '1px',
        alignItems: 'center',
        justifyContent: 'center',

    },
    contentHeading: {
        fontSize: '14px',
        letterSpacing: '0.03em',
        fontWeight: '600',
        display: 'flex',
        fontFamily: 'Roboto ,sans-serif',
        color: theme.palette.contentHeading,
    },
});

const SympathyWhatsAppropriateBlock = ({
    classes,
}) => {
    const {
        header_data: {
            title, casketFlowers, standingFlowers, funeralService, friends, funeralHome, sendingFlowers, subText, sympathyGifts,
        },
    } = Data;
    return (
        <>
            <PageHeading
                headingTitle={title}
                classes={classes}
                casketFlowers={casketFlowers}
                standingFlowers={standingFlowers}
                sympathyGifts={sympathyGifts}
                funeralService={funeralService}
                funeralHome={funeralHome}
                sendingFlowers={sendingFlowers}
                subText={subText}
                friends={friends}
            />
        </>
    );
};

SympathyWhatsAppropriateBlock.propTypes = {
    classes: object.isRequired,
};
export default withStyles(styles)(SympathyWhatsAppropriateBlock);
